import { SeuCanvasViewMode } from '@seu-types';

/**
 * Returns true when the canvas is not in edit mode (i.e. it is read-only).
 */
export function isCanvasReadonlyMode(
  viewMode: SeuCanvasViewMode | undefined
): boolean {
  return viewMode !== 'edit';
}
